import React, { useEffect, useState } from "react";
import Sidebar from "../../../layouts/sidebar";
import Headers from "../../../layouts/header";
import Select from "react-select";
import Datetime from "react-datetime";
import moment from "moment";
import "react-datetime/css/react-datetime.css";
import { Nav, Tab, Row, Col } from "react-bootstrap";
import { styled } from "@mui/material/styles";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import useAxiosFile from "../../../actions/useaxios";
import config from "../../../actions/config";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import Exportcsv from "./Exportcsv";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router";
import { DecryptData, EncryptData, isEmpty } from "../../../actions/common";

function SubCategorySeo() {
  const { toggle } = useSelector((state) => state.admin_panel.User);

  const navigate = useNavigate();

  const axiosFile = useAxiosFile();
  const {id,_id} = useParams()
  const [Datas, SetDatas] = useState([]);
  const [MetaTitle, SetMetaTitle] = useState([]);
  const [MetaDescription, SetMetaDescription] = useState([]);
  const [MetaP, SetMetaP] = useState([]);
  const [MetaH1, SetMetaH1] = useState([]);
 
  const [ValidateError, SetValidateError] = useState({});
  
  var {pathname} = useLocation()
  pathname = pathname.split('/')[1]
  console.log("pathname======",pathname)
  useEffect(() => {
  GetLocations();
  }, []);

  const GetLocations = async () => {
  
    var resp = await axiosFile.SubCategoryAction({ from: 'admin', action: pathname  ,id});
    console.log("dasdasdsadsa", resp);
    SetMetaTitle(resp?.data?.[0]?.MetaTitle)
    SetMetaDescription(resp?.data?.[0]?.MetaDescription)
    SetMetaH1(resp?.data?.[0]?.MetaH1)
    SetMetaP(resp?.data?.[0]?.MetaP)
}




    async function _add(params,showhome) {
      if(isEmpty(MetaTitle)){
        SetValidateError({
            MetaTitle:"MetaTitle required"
        })
        toast.error("MetaTitle required");
        return false
      }
      if(isEmpty(MetaDescription)) {
        SetValidateError({
            MetaDescription:"MetaDescription required"
        })
        toast.error("MetaDescription required");
        return false
      }
      if(isEmpty(MetaH1)) {
        SetValidateError({
            MetaH1:"MetaH1 required"
        })
        toast.error("MetaH1 required");
        return false
      }
      if(isEmpty(MetaP)) {
        SetValidateError({
            MetaP:"MetaP required"
        })
        toast.error("MetaP required");
        return false
      }

      let resp=  await axiosFile.SubCategoryAction({ id,from: 'admin', action: 'add-category-seo',MetaTitle,MetaDescription,MetaH1,MetaP});
      console.log("resp.success ",resp.success,resp?.msg );
      if(resp.success == "success") {
        toast.success(`Added Seo Successfully`);
        navigate(`/subcategorylist`)
        return
      }
      return toast.error(resp?.msg?resp?.msg:"data not updated right now");     
      }
     
 

 



  return (
    <>
      <div>
        <div className="innerpages">
          <div className="orders_pages">
            <Headers />
            <div className="container custom_container px-lg-0">
              <div className="row mx-auto">
                <div className="innerpages_wid px-0">
                  <Sidebar />
                  <div
                    className={
                      toggle
                        ? "content-sec-inner right_widthset content_without_sidebar"
                        : "content-sec-inner  content_with_sidebar"
                    }
                  >
                    <section id="content-wrapper">
                      <div class="row">
                        <div className="top_title_sec">
                          <div>
                            <p className="page_title mb-0">Category-SEO</p>
                          </div>
                        
                          {true?
                          <div className="rightside just_end ">
                            <button
                              type="button"
                              className="blue_btn add_deliveryprsn dp_btn_hover"
                              onClick={() => {navigate(`/Categorylist`)}}
                            >
                              Back
                            </button>

                          </div>:<></>}
                        </div>
                      </div>
                      {
                       
                      <div className="sec_border">
                      <Row className="mdv_inputrow">
                        <Col
                          xxl={6}
                          xl={6}
                          lg={6}
                          md={6}
                          sm={6}
                          xs={12}
                          className="mb-3"
                        >
                          <p className="mdv_inplabel"> Meta Title </p>
                          <input
                            className="mdv_cmninput"
                            value={MetaTitle}
                            type="text"
                            placeholder="Enter Question"
                            onChange={(e)=>SetMetaTitle(e?.target?.value)}
                          />
                       {ValidateError && ValidateError?.MetaTitle && (
                            <span className="error-msg">
                              {ValidateError.MetaTitle}
                            </span>
                          )}
                        </Col>
                        <Col
                          xxl={6}
                          xl={6}
                          lg={6}
                          md={6}
                          sm={6}
                          xs={12}
                          className="mb-3"
                        >
                          <p className="mdv_inplabel"> Meta Description </p>
                          <input
                            className="mdv_cmninput"
                            value={MetaDescription}
                            type="text"
                            placeholder="Enter Description"
                            onChange={(e)=>SetMetaDescription(e?.target?.value)}
                          />
                       {ValidateError && ValidateError?.MetaDescription && (
                            <span className="error-msg">
                              {ValidateError.MetaDescription}
                            </span>
                          )}
                        </Col>
                        <Col
                          xxl={6}
                          xl={6}
                          lg={6}
                          md={6}
                          sm={6}
                          xs={12}
                          className="mb-3"
                        >
                          <p className="mdv_inplabel"> H1 </p>
                          <input
                            className="mdv_cmninput"
                            value={MetaH1}
                            type="text"
                            placeholder="Enter MetaH1"
                            onChange={(e)=>SetMetaH1(e?.target?.value)}
                          />
                       {ValidateError && ValidateError?.MetaH1 && (
                            <span className="error-msg">
                              {ValidateError.MetaH1}
                            </span>
                          )}
                        </Col>
                        <Col
                          xxl={6}
                          xl={6}
                          lg={6}
                          md={6}
                          sm={6}
                          xs={12}
                          className="mb-3"
                        >
                          <p className="mdv_inplabel">  P tag</p>
                          <input
                            className="mdv_cmninput"
                            value={MetaP}
                            type="text"
                            placeholder="Enter MetaP"
                            onChange={(e)=>SetMetaP(e?.target?.value)}
                          />
                       {ValidateError && ValidateError?.MetaP && (
                            <span className="error-msg">
                              {ValidateError.MetaP}
                            </span>
                          )}
                        </Col>
                       
                    
                      
                  
                      </Row>
                      <div className="mdv_update_dualbtn mt-3">
                        <button
                          className="blue_btn mdv_update"
                          onClick={() => {_add()}}
                        >
                          {true? "save" :"edit"}
                        </button>
                      </div>
                      <div>
                        Notes: (keyword must be unique as given below)
                        <ul>
                        <li> Declare City name as "City name" </li>
                        <li> Declare store name as "Store Name" </li>
                        <li> Declare category name as "Services" </li>
                        <li> Declare sub category name as "Subcategory" </li>
                        <li> Declare product name as "Product Name" </li>
                        </ul>
                      </div>
                    </div>}
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SubCategorySeo;
